import React from "react";
import "./branding-item.css";

export default function BrandingItem({
  brand,
  background,
  link,
  button,
}: {
  brand: "boomerang" | "pg9" | "h4win" | "r4win" | "upcoming" | "stay-tuned";
  logo?: string;
  button?: string;
  background?: string;
  isMobile: boolean;
  link?: string;
}) {
  if (brand === "upcoming" || brand === "stay-tuned") {
    return (
      <div style={{ position: "relative" }}>
        <img src={background} width={"100%"} alt="PG9" />
      </div>
    );
  }

  return (
    <a
      href={link}
      style={{ textDecoration: "none", position: "relative" }}
      target="_blank"
      rel="noreferrer"
    >
      <div className={`${brand}-class`}>
        <img
          src={background}
          width={"100%"}
          alt={brand}
          style={{ objectFit: "contain" }}
        />
        <div
          style={{
            bottom: 0,
            left: 0,
            right: 0,
            padding: "20px",
            position: "absolute",
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "column",
          }}
        >
          <img src={button} alt="ButtonBg" className={`${brand}-animation`} />
        </div>
      </div>
    </a>
  );
}
